import React from 'react';

export default function NoResults(): JSX.Element {
  return (
    <div className="no-results">
      <p className="lead">
        No results were found. Here&apos;s some suggestions that might help:
      </p>
      <ul>
        <li>Try removing filters or keywords.</li>
        <li>Check your search for typos or spelling errors.</li>
        <li>
          If you&apos;re searching for a legacy report (one that is no longer
          maintained by DrJ), try unchecking &lsquo;Hide Legacy
          Documents&rsquo;.
        </li>
      </ul>
    </div>
  );
}
